var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickupProgressComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666664,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#E34B31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4167 12.25V22.875C25.4167 23.9105 24.5772 24.75 23.5417 24.75H9.79166C8.75612 24.75 7.91666 23.9102 7.91666 22.875V12.25H14.1667V16.625C14.1667 16.9688 14.4479 17.25 14.7917 17.25H18.5417C18.8854 17.25 19.1667 16.9688 19.1667 16.625L19.1315 12.25H25.4167Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3202 7.25C10.778 7.25 10.3046 7.5918 10.1335 8.10469L7.93131 12.2031C7.93864 12.2129 7.94352 12.2197 7.9484 12.2266C7.95329 12.2334 7.95817 12.2402 7.96549 12.25H14.1667V16.625C14.1667 17 14.4167 17.25 14.7917 17.25H18.5417C18.9167 17.25 19.1667 17 19.1667 16.625L19.1315 12.25H14.1667L15.4167 7.25H11.3202ZM23.2018 8.10469C23.0299 7.5918 22.5573 7.25 22.0143 7.25H17.9167L19.1655 12.25H25.3686C25.3759 12.2402 25.3808 12.2329 25.3857 12.2256C25.3906 12.2183 25.3955 12.2109 25.4028 12.2012L23.2018 8.10469Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupProgressComplete);
export default __webpack_public_path__ + "static/media/pickup-progress-complete.b6f3cb11dd4ca792fbc9e64b4b462a9f.svg";
export { ForwardRef as ReactComponent };